import { validatorFromFunction } from "validate-redux-form";

export const NOT_EMPTY_REGEX = /\S/;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const notEmpty = validatorFromFunction(
  value => (typeof value === "string" ? value.match(NOT_EMPTY_REGEX) : !!value)
);



// WEBPACK FOOTER //
// ./src/utils/validation.js